module.exports = __webpack_public_path__ + "static/media/fornecedor.02818425.jpg";